export const LIST_ESPECE_CATEGORY = [
  { value: "ELEVAGE", label: "Elevage" },
  /* { value: "COMPAGNIE", label: "Compagnie" },
  { value: "ALL", label: "Toutes" }, */
];
export const LIST_ESPECE_CATEGORY_CIV = [
  { value: "ELEVAGE", label: "Elevage" },
  { value: "COMPAGNIE", label: "Compagnie" },
  { value: "ALL", label: "Toutes" },
];
export const LIST_ELEVAGE_TYPE = [
  { value: "PRODUCTION_LAIT", label: "Production de lait" },
  { value: "PRODUCTION_VIANDE", label: "Production de viande" },
  { value: "AMELIORATION_GENETIQUE", label: "Amélioration Génétique" },
  { value: "TRACTION", label: "Traction" },
];
export const LIST_ANIMAL_STATUS = [
  { value: "IMPORTED", label: "Importé" },
  { value: "TRANSIT", label: "En Transit" },
  { value: "NOT_IMPORTED", label: "Non Importé" },
];
